module.exports = __webpack_public_path__ + "media/assets/images/category/Hanukkah@2x-30322c25d6057f8957ccafef1ad41026.png";